import ThemeConfig from '../theme-config';

const themeConfig: ThemeConfig = {
  data: {
    language: 'de',
  },
};

export default themeConfig;
